import script from "./BenefitsView.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitsView.vue?vue&type=script&setup=true&lang=js"

import "./BenefitsView.vue?vue&type=style&index=0&id=a1a333da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1a333da"]])

export default __exports__